import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/mobile-hero1.svg'
import _imports_1 from '../../../assets/images/android.svg'
import _imports_2 from '../../../assets/images/apple.svg'
import _imports_3 from '../../../assets/images/tir-shape.svg'


const _hoisted_1 = { className: "flex flex-row mx-auto max-w-7xl px-2 sm:px-6 lg:px-8 pt-[11rem] flex-wrap pb-[6rem] overflow-hidden" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { className: "md:w-2/5 sm:order-2" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      className: "m-auto object-contain relative left-[2rem] sm:left-0",
      src: _imports_0,
      alt: "mobilehero"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { className: "md:w-3/5 sm:order-1" }, [
  /*#__PURE__*/_createElementVNode("div", { className: "text-[2.25rem] md:text-[5.25rem] font-[Poppins-Medium] text-[Black] font-[700] sm:text-left text-center leading-[1.1] pt-[4rem]" }, " Get your items delivered swiftly "),
  /*#__PURE__*/_createElementVNode("div", { className: "md:w-3/4 pt-2 text-[#2D2D2D] sm:text-left text-center" }, " We provide you with variety of affordable delivery options and as well help you keep record of the deliveries. "),
  /*#__PURE__*/_createElementVNode("div", { className: "pt-[3rem]  flex sm:justify-start justify-center " }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "android",
      className: "mr-2"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      alt: "apple"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_3,
      alt: "tirShape",
      className: "relative bottom-[1.75rem] z-[-1] sm:block hidden"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}